import { createTDealApiStore } from '@/api'
import config from '@/config'
import { getDefineName, getSortData } from '@/utils/utils'
import { dateFormat, getToday, getStrYMDHM, getStrHM, getStrDate, getWeek, moveMonth, getStrYM, addMonth, getStrMDW, getStrMD, addDay, moveDay, getMonday, getStrYMDHMSS } from '@/utils/DateUtils'
import { formatCurrency } from '@/utils/StringUtils'

const apiStore = createTDealApiStore([
  {
    action: '_history',
    path: 'history',
    method: 'get',
    cacheable: false
  },
  {
    action: '_fileUpload',
    path: 'fileUpload',
    method: 'post',
    cacheable: false
  },
  {
    action: '_imageUpload',
    path: 'imageUpload',
    method: 'post',
    cacheable: false
  }
])
export default {
  namespaced: true,
  mixins: [apiStore],
  actions: {
    history({ state, dispatch, commit }, params) {
      return dispatch('_history', { params: params })
    },
    fileUpload({ state, dispatch, commit, getters, rootGetters }, data) {
      let formData = getters.jsonToFormData(data)
      return dispatch('_fileUpload', { data: formData })
    },
    dataURItoBlob({ state, dispatch, commit, getters, rootGetters }, data) {
      let dataURI = data.dataURI
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length)

      // create a view into the buffer
      var ia = new Uint8Array(ab)

      // set the bytes of the buffer to the correct values
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      // write the ArrayBuffer to a blob, and you're done
      var blob = new Blob([ab], { type: mimeString })
      return blob
    }
  },
  getters: {
    addMonth: () => (date, cnt, separator) => {
      return addMonth(date, cnt, separator)
    },
    hourData() {
      return JSON.parse(JSON.stringify(config.defines.commons.hourData))
    },
    minuteData() {
      let minute = []
      Array(60)
        .fill()
        .forEach((_, index) => {
          let obj = { id: index, code: index.toString(), name: index < 10 ? '0' + index.toString() : index.toString() }
          minute.push(obj)
        })
      return JSON.parse(JSON.stringify(minute))
    },
    validTextLength1(text) {
      if (text === undefined) return 0
      else return text.length
    },
    validTextLength: () => text => {
      if (text === undefined) return 0
      else return text.length
    },
    rangeNumberData: () => range => {
      let num = []
      Array(range)
        .fill()
        .forEach((_, index) => {
          let count = index + 1
          let obj = { id: count, code: count.toString(), name: count < 10 ? '0' + count.toString() : count.toString() }
          num.push(obj)
        })
      return JSON.parse(JSON.stringify(num))
    },
    useData() {
      return JSON.parse(JSON.stringify(config.defines.commons.useData))
    },
    getDefineName: () => (key, subKey, code, targetNames) => {
      return getDefineName(key, subKey, code, targetNames)
    },
    getToday: () => () => {
      return getToday()
    },
    getStrYMDHM: () => (val, separator) => {
      return getStrYMDHM(val, separator)
    },
    getStrHM: () => val => {
      return getStrHM(val)
    },
    getStrYM: () => (val, separator) => {
      return getStrYM(val, separator)
    },
    getStrDate: () => (val, separator) => {
      return getStrDate(val, separator)
    },
    formatCurrency: () => val => {
      return formatCurrency(val)
    },
    getWeek: () => val => {
      return getWeek(val)
    },
    getStrMDW: () => (val, separator, lan) => {
      return getStrMDW(val, separator, lan)
    },
    getStrMD: () => (val, separator) => {
      return getStrMD(val, separator)
    },
    getStrYMDHMSS: () => (val, separator) => {
      return getStrYMDHMSS(val, separator)
    },
    addDay: () => (val, cnt, separator) => {
      return addDay(val, cnt, separator)
    },
    activeData() {
      return JSON.parse(JSON.stringify(config.defines.commons.activeData))
    },
    visibleData() {
      return JSON.parse(JSON.stringify(config.defines.commons.visibleData))
    },
    monthData: (state, getters) => {
      return JSON.parse(JSON.stringify(config.defines.commons.monthData))
    },
    moveMonth: () => (date, separator, moveCnt) => {
      return moveMonth(date, separator, moveCnt)
    },
    moveDay: () => (date, separator, moveCnt) => {
      return moveDay(date, separator, moveCnt)
    },
    dateFormat: () => (date, separator) => {
      return dateFormat(date, separator)
    },
    getMonday: () => (date, obj) => {
      return getMonday(date, obj)
    },
    jsonToFormData: () => data => {
      // console.log(data)
      let formData = new FormData()
      Object.keys(data).forEach(function (key) {
        if (typeof data[key] === 'object' && !(data[key] instanceof File) && data[key] !== null) {
          Object.keys(data[key]).forEach(function (subkey) {
            if (data[key][subkey] instanceof File || subkey === 'image') {
              delete data[key][subkey]
            }
          })
          formData.append(key, JSON.stringify(data[key]))
        } else {
          formData.append(key, data[key])
        }
      })

      return formData
    },
    handleNewLine: () => (str, addHtml) => {
      if (!str) return ''
      return String(str).replace(/(?:\r\n|\r|\n)/g, '</br>')
    },
    checkedCheckboxAll: () => (datas, value) => {
      datas.forEach((item, index) => {
        item.checked = value
      })
      return datas
    },
    checkedCheckbox: () => (datas, value, index) => {
      let checkedAll = false
      datas[index].checked = value

      let checkedLength = datas.filter(function (item) {
        if (item.checked === true) {
          return item
        }
      }).length
      if (datas.length === checkedLength) {
        checkedAll = true
      }
      return { datas: datas, checkedAll: checkedAll }
    },
    getSortData: () => (data, key, type) => {
      return getSortData(data, key, type)
    }
  }
}
